import Skeleton from '@mui/material/Skeleton';
import ApplicationSpinner from '@/Infrastructure/Components/Loading/ApplicationSpinner';
import { useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import EllipsisIcon from '@mui/icons-material/MoreVertTwoTone';
import { useAppSelector } from '@reduxStore';
import { selectAppFeatures } from '@/Infrastructure/Utilities/appSelectors';

import classNames from 'classnames/bind';

import styles from './DispatchGrid.module.css';

const cx = classNames.bind(styles);

export default function DispatchSkeleton() {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const featureFlags = useAppSelector((state) => selectAppFeatures(state));

  if (isMobile) {
    return (
      <div className={cx('container', 'skeleton-container')}>
        <div className={styles['dispatch-toolbar-skeleton']}>
          <EllipsisIcon color='disabled' />
          <Skeleton
            variant='rounded'
            width={225}
            height={32}
          />
          {featureFlags?.editBoardQueries && (
            <Skeleton
              variant='circular'
              width={34}
              height={34}
            />
          )}
          <Skeleton
            variant='circular'
            width={34}
            height={34}
          />
          <div className={styles['flex-end']}>
            <Skeleton
              variant='circular'
              width={34}
              height={34}
            />
          </div>
        </div>
        <div className={cx('skeleton-spinner')}>
          <ApplicationSpinner />
        </div>
      </div>
    );
  }

  return (
    <div className={cx('container', 'skeleton-container')}>
      <div className={styles['dispatch-toolbar-skeleton']}>
        <Skeleton
          variant='rounded'
          width={225}
          height={32}
        />
        {featureFlags?.editBoardQueries && (
          <Skeleton
            variant='circular'
            width={34}
            height={34}
          />
        )}
        <Skeleton
          variant='circular'
          width={34}
          height={34}
        />
        <Skeleton
          variant='circular'
          width={34}
          height={34}
        />
        <div className={styles['flex-end']}>
          <Skeleton
            variant='circular'
            width={34}
            height={34}
          />
          <Skeleton
            variant='circular'
            width={34}
            height={34}
          />
          <Skeleton
            variant='rounded'
            width={260}
            height={32}
          />
          <Skeleton
            variant='rounded'
            width={80}
            height={32}
          />
        </div>
      </div>
      <div className={cx('skeleton-spinner')}>
        <ApplicationSpinner />
      </div>
    </div>
  );
}
